module.exports = __webpack_public_path__ + "media/满意.aeb0012f.mp3";